import { HashRouter } from "react-router-dom";

//electron发布模式下，需要开启hash路由
const Router = ({children})=>{
    if(window.$electronRelease) return <HashRouter>{children}</HashRouter>;
    return children;
}

export default Router;
